export const common = {
  // ナビゲーション
  nav_home: 'ホーム',
  nav_services: '事業紹介',
  nav_cases: '実績・事例',
  nav_media: 'メディア実績',
  nav_news: 'ニュース',
  nav_recruit: '採用情報',
  nav_company: '会社情報',
  nav_contact: 'お問い合わせ',
  
  // CTA
  cta_interview: '取材のご相談',
  cta_partnership: '共同事業のご相談',
  cta_services: 'サービスを見る',
  cta_cases: '実績・事例を見る',
  
  // 共通
  company_name: 'ナインバレー株式会社',
  read_more: '続きを読む',
  view_all: 'すべて見る',
  contact_us: 'お問い合わせ',
  download: '資料ダウンロード',
  
  // フッター
  footer_address: '〒753-0056 山口県山口市湯田温泉2丁目4-26',
  footer_email: 'info@redondo.jp',
  footer_copyright: '© 2019 Nine Valley Inc.',
  footer_made_with_readdy: 'Made with Readdy'
};